export enum OrderAction {
    AMOUNT = 'Amount',
    SHARES = 'Shares',
    TOTAL = 'Total',
}
